import { useState } from 'react';

export function useVersionSelection() {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const selectedCount = selectedIds.size;

  const isSelected = (id: string): boolean => {
    return selectedIds.has(id);
  };

  const toggleSelection = (id: string) => {
    setSelectedIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const toggleSelectAll = (allIds: string[]) => {
    if (selectedIds.size === allIds.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(allIds));
    }
  };

  const clearSelection = () => {
    setSelectedIds(new Set());
  };

  const getSelectedArray = (): string[] => {
    return Array.from(selectedIds);
  };

  return {
    selectedIds,
    selectedCount,
    isSelected,
    toggleSelection,
    toggleSelectAll,
    clearSelection,
    getSelectedArray,
  };
}
